import React, { useState } from "react";
import { Box, IconButton, Paper, Switch } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import AdjustIcon from '@mui/icons-material/Adjust';
import RefreshIcon from '@mui/icons-material/Refresh';

const MapToolbar = ({ showDevice, isRoutesPolygonShow, showPolygon, shouldShowSimpleRoute, funShouldShowSimpleRoute, regenerateRoutes }) => {
    const [open, setOpen] = useState(false);

    return (
        <Box sx={{ position: "absolute", bottom: 0, left: 0, width: "100%", height: "100%", pointerEvents: "none" }}>
            {/* Toggle Button positioned on the map */}
            <IconButton
                sx={{
                    position: "absolute",
                    bottom: 20,
                    left: 20,
                    zIndex: 1000,
                    backgroundColor: "blue",
                    boxShadow: 3,
                    pointerEvents: "auto",
                }}
                onClick={() => setOpen(true)}
            >
                <MenuIcon />
            </IconButton>
            <IconButton
                sx={{
                    position: "absolute",
                    bottom: 20,
                    left: 70,
                    zIndex: 1000,
                    backgroundColor: "white",
                    boxShadow: 3,
                    pointerEvents: "auto",
                }}
                title="Locate Device"
                onClick={() => showDevice()}>
                <AdjustIcon sx={{ color: 'blue', fontSize: '20px' }} />
            </IconButton>

            {/* Sidebar (Slide-in from Left) */}
            {
                open ?
                    <Paper
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: open ? 0 : "-250px", // Show or hide
                            width: "250px",
                            height: "100%",
                            backgroundColor: "white",
                            boxShadow: 3,
                            transition: "left 0.3s ease-in-out",
                            zIndex: 99999,
                            p: 2,
                            pointerEvents: "auto",
                        }}
                    >
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <h3>Toolbar</h3>
                            <IconButton onClick={() => setOpen(false)}>
                                <CloseIcon sx={{ color: 'red' }} />
                            </IconButton>
                        </Box>
                        {/* <div>
                            Locate Device: <IconButton onClick={() => showDevice()}>
                                <AdjustIcon sx={{ color: 'blue' }} />
                            </IconButton>
                        </div> */}
                        <div>
                            Show Routes: <Switch checked={isRoutesPolygonShow} onChange={() => showPolygon()} />
                        </div>
                        {
                            isRoutesPolygonShow ?
                                <div>
                                    Show Snap To Roads: <Switch checked={shouldShowSimpleRoute} onChange={() => funShouldShowSimpleRoute(!shouldShowSimpleRoute)} />
                                </div> : <></>
                        }
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            Regenerate Routes: <IconButton onClick={() => regenerateRoutes()} sx={{  pointerEvents: "auto" }} ><RefreshIcon sx={{ color: 'blue', fontSize: '20px' }} /></IconButton>
                        </div>
                    </Paper> : <></>
            }
        </Box>
    );
};

export default MapToolbar;
